import { Chip, Tooltip } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { green, grey } from "@mui/material/colors";

interface AccountStatusChipProps {
  accountStatus: string;
}

export function AccountStatusChip({ accountStatus }: AccountStatusChipProps) {
  return (
    <>
      {accountStatus === "Verified" ? (
        <Chip
          label={accountStatus}
          icon={<CheckCircleOutlineIcon style={{ color: "white" }} />}
          style={{
            backgroundColor: green[300],
            color: "white",
          }}
        />
      ) : (
        <Tooltip
          title="Waiting for the user to create the MagiCAD account"
          placement="right"
        >
          <Chip
            label={accountStatus}
            icon={<AccessTimeIcon style={{ color: "darkgrey" }} />}
            style={{
              backgroundColor: grey[300],
              color: "darkgrey",
            }}
          />
        </Tooltip>
      )}
    </>
  );
}